{
  "404": {
    "title": "Esta página se ha ido a pescar",
    "text": "Si crees que esto no es correcto, por favor envíanos un mensaje a ",
    "back_button": "Volver al tablero"
  },
  "intro": {
    "typed1": "Cada cuerpo cuenta una historia, empieza a escribir la tuya.",
    "typed2": "Hoy es el mejor día para empezar.",
    "typed3": "Tu mejor versión está más cerca de lo que crees.",
    "signinBtn": "Comienza ahora",
    "loginBtn": "Inicia sesión"
  },
  "signUp": {
    "title": "Regístrate",
    "have-account": "¿Tienes una cuenta?",
    "acceptTermsConditions": "Acepto la Política de Privacidad y los Términos y Condiciones de Uso.",
    "access": "Accede",
    "submitBtn": "Crear cuenta",
    "request": "¡Registro completado con éxito! Ya puedes comenzar a registrar tus medidas y seguir tu progreso con FitBodyTrack. ¡Vamos a por tus objetivos!",
    "read": "Leer"
  },
  "login": {
    "title": "Iniciar sesión",
    "newInFTB": "¿Eres nuevo en FitBodyTrack?",
    "signUp": "Regístrate",
    "forgotPass": "¿Has olvidado la contraseña?",
    "submitBtn": "Acceder"
  },
  "dashboard": {
    "current-measurements-alert": "A continuación se muestran tus medidas corporales más recientes registradas.",
    "empty-alert": "Este es el primer paso hacia tus objetivos. Añade tu primera medida y empieza a transformar tu cuerpo."
  },
  "measures": {
    "measure": "Medida",
    "editMeasure": "Editar medida",
    "antebrazo_dcho": "Antebrazo derecho",
    "antebrazo_izdo": "Antebrazo izquierdo",
    "biceps_dcho": "Biceps derecho",
    "biceps_izdo": "Biceps izquierdo",
    "cadera": "Cadera",
    "cintura": "Cintura",
    "cuello": "Cuello",
    "muslo_dcho": "Muslo derecho",
    "muslo_izdo": "Muslo izquierdo",
    "gemelo_dcho": "Gemelo derecho",
    "gemelo_izdo": "Gemelo izquierdo",
    "pecho": "Pecho",
    "peso": "Peso corporal",
    "antebrazo_tooltip": "Rodea el antebrazo en la parte más ancha, con el brazo relajado y colgando junto al cuerpo.",
    "biceps_tooltip": "Mide el contorno del bíceps en su punto más ancho, con el brazo relajado (no flexionado).",
    "cadera_tooltip": "Coloca la cinta en la parte más ancha de los glúteos y asegúrate de que quede nivelada.",
    "cintura_tooltip": "Mide en el punto más estrecho del torso, normalmente justo por encima del ombligo.",
    "cuello_tooltip": "Pasa la cinta alrededor de la base del cuello, justo debajo de la nuez.",
    "muslo_tooltip": "Mide la parte superior del muslo, justo debajo del pliegue del glúteo, en el punto más ancho.",
    "gemelo_tooltip": "Rodea el gemelo en la parte más ancha, con el pie apoyado y la pierna relajada.",
    "pecho_tooltip": "Coloca la cinta a la altura de los pezones, pasando por la parte más prominente del pecho.",
    "peso_tooltip": "Introduce tu peso corporal actual en kilogramos. Lo ideal es pesarte siempre a la misma hora del día (preferiblemente en ayunas) para obtener mediciones consistentes.",
    "date": "Fecha de medición",
    "save": "Guardar medida",
    "chart-type": "Tipo de gráfica",
    "chart-type-line": "Línea",
    "chart-type-bars": "Barras",
    "request": "¡Mediciones guardadas con éxito! Tu progreso ha sido actualizado.",
    "confirmDelete": "¿Seguro que quieres eliminar esta medida?",
    "emptyHistory": "Todavía no has registrado ninguna medida. Añade tu primera para comenzar a seguir tu evolución.",
    "foto_frontal": "Foto frontal",
    "foto_perfil": "Foto de perfil",
    "foto_espalda": "Foto de espalda",
    "images-alert": "¿Quieres ver tu evolución física con mayor claridad?",
    "images-alert2": "Puedes subir imágenes de tu estado actual (frontal, perfil y espalda). Así podrás comparar visualmente tu progreso con el paso del tiempo."
  },
  "language": {
    "brazilian_portuguese": "Portugués brasileño",
    "english": "Inglés",
    "spanish": "Español",
    "simplified_chinese": "Chino simplificado",
    "persian": "Persa"
  },
  "menu": {
    "dashboard": "Inicio",
    "addMeasurement": "Añadir medidas",
    "my-evolution": "Mi evolución",
    "history": "Historial",
    "profile": "Perfil",
    "preferences": "Mi perfil",
    "logout": "Cerrar sesión"
  },
  "profile": {
    "name": "Nombre",
    "namePh": "Introduce tu nombre",
    "nameRequired": "El campo nombre es obligatorio",
    "surname": "Apellidos",
    "surnamePh": "Introduce tus apellidos",
    "surnameRequired": "El campo apellidos es obligatorio",
    "gender": "Género",
    "gender0": "Femenino",
    "gender1": "Masculino",
    "gender2": "Prefiero no decirlo",
    "genderRequired": "El campo género es obligatorio",
    "height": "Altura",
    "heightPh": "Introduce tu altura",
    "email": "Email",
    "emailPh": "Introduce tu email",
    "emailRequired": "El campo email es obligatorio",
    "emailValid": "El campo email debe contener una dirección válida",
    "password": "Contraseña",
    "passwordRequired": "El campo contraseña es obligatorio",
    "passwordMin": "El campo contraseña debe contener al menos 8 caracteres",
    "passwordMinLetter": "El campo contraseña debe contener al menos una letra",
    "passwordMinNumber": "El campo contraseña debe contener al menos un número",
    "passwordMinSpecialCharacter": "El campo contraseña debe contener al menos un caracter especial",
    "passwordMsg": "La contraseña debe contener más de 8 caracteres: letras, números y caracteres especiales.",
    "passwordRepeat": "Repetir contraseña",
    "passwordRepeatRequired": "El campo repetir contraseña es obligatorio",
    "change-password": "Cambiar contraseña",
    "edit": "Editar",
    "save": "Guardar",
    "theme": "Tema",
    "lightTheme": "Tema claro",
    "darkTheme": "Tema oscuro",
    "account": "Cuenta",
    "language": "Idioma",
    "request": "Tu perfil ha sido actualizado."
  },
  "legal-notice": {
    "title": "Aviso Legal",
    "txt1": "En cumplimiento con lo dispuesto en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa a los usuarios de los siguientes datos: la identidad es {fullname}, con DNI {nif}, la dirección postal es {address}, y el correo electrónico de contacto es {email}. El acceso y uso de este sitio web atribuye la condición de usuario, que acepta desde dicho acceso y uso las presentes condiciones legales."
  },
  "privacy-policy": {
    "title": "Política de Privacidad",
    "txt1": "De conformidad con el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos Personales (LOPDGDD), se informa a los usuarios de lo siguiente:",
    "txt2": "Responsable del tratamiento",
    "txt2a": "Responsable:",
    "txt2b": "DNI:",
    "txt2c": "Correo electrónico de contacto:",
    "txt3": "Datos recogidos",
    "txt3a": "Registro de usuario:",
    "txt3a1": "nombre, apellidos, género, email, contraseña.",
    "txt3b": "Login",
    "txt3b1": "email y contraseña.",
    "txt3c": "Mediciones corporales",
    "txt3c1": "datos que el usuario decida introducir.",
    "txt3d": "Imágenes",
    "txt3d1": "hasta 3 fotografías por cada entrada, almacenadas en el servidor para uso personal del usuario.",
    "txt3e": "Cookies y datos de navegación",
    "txt3e1": "datos técnicos, analíticos y publicitarios (ver Política de Cookies).",
    "txt4": "Finalidad del tratamiento",
    "txt4a": "Gestionar el acceso y uso de la plataforma.",
    "txt4b": "Permitir al usuario registrar y consultar sus medidas corporales.",
    "txt4c": "Almacenar y mostrar imágenes subidas por el usuario.",
    "txt4d": "Cumplimiento de obligaciones legales.",
    "txt4e": "Mostrar anuncios personalizados a través de Google AdSense.",
    "txt5": "Conservación de los datos",
    "txt5a": "Los datos personales se conservarán mientras el usuario mantenga su cuenta activa. El usuario podrá solicitar la eliminación en cualquier momento escribiendo a",
    "txt6": "Legitimación",
    "txt6a": "Consentimiento expreso del usuario.",
    "txt6b": "Ejecución de la relación contractual (registro y acceso a la plataforma).",
    "txt6c": "Interés legítimo en la mejora de los servicios y en la monetización mediante publicidad.",
    "txt7": "Destinatarios",
    "txt7a": "Google Ireland Limited (AdSense) y otros terceros autorizados por Google para la personalización de anuncios.",
    "txt7b": "No se cederán datos personales a terceros distintos salvo obligación legal.",
    "txt8": "Derechos",
    "txt8a": "Los usuarios pueden ejercer los derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad, escribiendo a"
  },
  "terms-conditions": {
    "title": "Términos y Condiciones de Uso",
    "txt1": "Objeto",
    "txt1a": "Estos términos regulan el acceso y uso de la aplicación FitBodyTrack.",
    "txt2": "Registro de usuario",
    "txt2a": "El usuario se compromete a facilitar datos veraces y a mantener la confidencialidad de sus credenciales de acceso.",
    "txt3": "Uso de la plataforma",
    "txt3a": "El usuario es responsable de los datos y las imágenes que introduzca.",
    "txt3b": "Está prohibido subir contenido ofensivo, ilícito o que infrinja derechos de terceros.",
    "txt3c": "Las imágenes se almacenan solo para el uso del propio usuario dentro de la aplicación.",
    "txt4": "Propiedad intelectual",
    "txt4a": "El titular de la plataforma ostenta los derechos de propiedad intelectual sobre la aplicación, salvo los contenidos aportados por los usuarios.",
    "txt5": "Publicidad",
    "txt5a": "La web se financia mediante publicidad de Google AdSense. El usuario acepta que durante el uso de la plataforma podrá visualizar anuncios.",
    "txt6": "Exclusión de responsabilidad",
    "txt6a": "El titular no se hace responsable de interrupciones técnicas, errores en los anuncios mostrados por Google ni del uso indebido de la aplicación por parte de los usuarios.",
    "txt7": "Eliminación de la cuenta",
    "txt7a": "El usuario puede solicitar la eliminación de su cuenta y de todos sus datos escribiendo a",
    "txt8": "Modificación de los términos",
    "txt8a": "El titular podrá modificar en cualquier momento los presentes términos, informando al usuario en caso de cambios relevantes."
  },
  "vuestic": {
    "search": "Buscar",
    "noOptions": "No se encontraron elementos",
    "ok": "Aceptar",
    "cancel": "Cancelar",
    "uploadFile": "Seleccionar archivo",
    "undo": "Deshacer",
    "dropzone": "Suelta los archivos aquí para subirlos",
    "fileDeleted": "Archivo eliminado",
    "closeAlert": "cerrar alerta",
    "backToTop": "volver al inicio",
    "toggleDropdown": "alternar menú desplegable",
    "carousel": "carrusel",
    "goPreviousSlide": "ir a la diapositiva anterior",
    "goNextSlide": "ir a la siguiente diapositiva",
    "goSlide": "ir a la diapositiva {index}",
    "slideOf": "diapositiva {index} de {length}",
    "close": "cerrar",
    "openColorPicker": "abrir selector de color",
    "colorSelection": "selección de color",
    "colorName": "color {color}",
    "decreaseCounter": "disminuir contador",
    "increaseCounter": "aumentar contador",
    "selectAllRows": "seleccionar todas las filas",
    "sortColumnBy": "ordenar columna por {name}",
    "selectRowByIndex": "seleccionar fila {index}",
    "resetDate": "restablecer fecha",
    "nextPeriod": "siguiente periodo",
    "switchView": "cambiar vista",
    "previousPeriod": "periodo anterior",
    "removeFile": "eliminar archivo",
    "reset": "restablecer",
    "pagination": "paginación",
    "goToTheFirstPage": "ir a la primera página",
    "goToPreviousPage": "ir a la página anterior",
    "goToSpecificPage": "ir a la página {page}",
    "goToSpecificPageInput": "ingresa el número de página",
    "goNextPage": "ir a la siguiente página",
    "goLastPage": "ir a la última página",
    "currentRating": "calificación actual {value} de {max}",
    "voteRating": "votar calificación {value} de {max}",
    "optionsFilter": "filtro de opciones",
    "splitPanels": "paneles divididos",
    "movePaginationLeft": "mover paginación a la izquierda",
    "movePaginationRight": "mover paginación a la derecha",
    "resetTime": "restablecer hora",
    "closeToast": "cerrar notificación",
    "selectedOption": "Opción seleccionada",
    "noSelectedOption": "No se ha seleccionado una opción",
    "breadcrumbs": "migas de pan",
    "counterValue": "valor del contador",
    "selectedDate": "fecha seleccionada",
    "selectedTime": "hora seleccionada",
    "progressState": "estado del progreso",
    "color": "color",
    "next": "Siguiente",
    "back": "Anterior",
    "finish": "Finalizar",
    "step": "paso",
    "progress": "progreso",
    "loading": "Cargando",
    "sliderValue": "El valor actual del control deslizante es {value}",
    "switch": "Cambiar",
    "inputField": "Campo de entrada",
    "fileTypeIncorrect": "El tipo de archivo es incorrecto",
    "select": "Selecciona una opción"
  }
}
